var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FEE6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9 15C9 13.3431 10.3431 12 12 12L18 12C19.6569 12 21 13.3431 21 15V19.5C21 21.1569 19.6569 22.5 18 22.5H12C10.3431 22.5 9 21.1569 9 19.5L9 15Z",
    fill: "#DE8D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 15.9375C15.3107 15.9375 15.5625 16.1893 15.5625 16.5V18C15.5625 18.3107 15.3107 18.5625 15 18.5625C14.6893 18.5625 14.4375 18.3107 14.4375 18V16.5C14.4375 16.1893 14.6893 15.9375 15 15.9375Z",
    fill: "#DE8D8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5625 10.5C12.5625 9.15381 13.6538 8.0625 15 8.0625C16.3462 8.0625 17.4375 9.15381 17.4375 10.5V12H18C18.1923 12 18.3803 12.0181 18.5625 12.0526V10.5C18.5625 8.53249 16.9675 6.9375 15 6.9375C13.0325 6.9375 11.4375 8.53249 11.4375 10.5L11.4375 12.0526C11.6197 12.0181 11.8077 12 12 12H12.5625L12.5625 10.5Z",
    fill: "#DE8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSecurity);
export default __webpack_public_path__ + "static/media/menu_security.cc93a88a097c3e9ab94d537a736fe6f0.svg";
export { ForwardRef as ReactComponent };